import React from "react";
import styles from "./styles.module.scss";
import { authService } from "../../../../../../services/AuthService";
import { TWO_FACTOR_TYPES } from "../../../../../../consts/api";
import { Radio } from "../../../../../../shared/Radio/Radio";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";

export function Options({ value, onChange }) {
  const preLoginData = authService.getPreLoginData();

  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  return (
    <div className={styles.root}>
      {[TWO_FACTOR_TYPES.email, TWO_FACTOR_TYPES.google].includes(
        preLoginData.twoFactorType,
      ) && (
        <Radio
          name="altType"
          label={t("method.sms")}
          isChecked={value === TWO_FACTOR_TYPES.sms}
          onChange={() => onChange(TWO_FACTOR_TYPES.sms)}
        />
      )}
      {[TWO_FACTOR_TYPES.sms, TWO_FACTOR_TYPES.google].includes(
        preLoginData.twoFactorType,
      ) && (
        <Radio
          name="altType"
          label={t("method.email")}
          isChecked={value === TWO_FACTOR_TYPES.email}
          onChange={() => onChange(TWO_FACTOR_TYPES.email)}
        />
      )}
    </div>
  );
}
